import styled from 'styled-components';

export const Guardians = styled.div`
  border-left: 1px solid #eee;
  padding-left: 1rem;
  margin-top: -0.5rem;
  margin-bottom: 1rem;
`;
